module.exports = __webpack_public_path__ + "img/图层661.cf290eec.png";